import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../lib/axios";
import { API_PORTAL_URL } from "../lib/config";

export const getAllActiveActivity = createAsyncThunk(
  "Activity/FindAllActiveActivity",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Activity/FindAllActiveActivity`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getActivityByURL = createAsyncThunk(
  "Activity/ActivityFindByURL",
  async (ActivityURL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Activity/ActivityFindByURL`,
        { ActivityURL },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error fetching Activity :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export interface ActivityState {
  loading: boolean;
  error: string;
  activityDetails: any;
  ActivityList: any[];
}

const initialState: ActivityState = {
  loading: false,
  error: "",
  activityDetails: null,
  ActivityList: [],
};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllActiveActivity.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveActivity.fulfilled, (state, action) => {
      state.loading = false;
      state.ActivityList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveActivity.rejected, (state, action) => {
      state.loading = false;
      state.ActivityList = [];
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getActivityByURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getActivityByURL.fulfilled, (state, action) => {
      state.loading = false;
      state.activityDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getActivityByURL.rejected, (state, action) => {
      state.loading = false;
      state.activityDetails = null;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default activitySlice.reducer;
